<template>
  <form
    v-on:submit.prevent="paginationSearch"
  >
    <fieldset>
      <legend>Search {{ legend }}</legend>

      <div class="row">
        <div
          class="col col-2"
        >
          <span
            v-if="!labels.length"
          >
            <label
              for="query"
              class="col-form-label"
            >
              {{ label }}
            </label>
          </span>
          <span
            v-else
          >
            <select
              class="form-control"
              v-on:change="labelSelected"
            >
              <option
                v-for="label, idx in labels"
                :value="label.action"
                :data-search-action="label.action"
                :selected="isSelected(label.action)"
              >
                {{ label.lbl }}
              </option>
            </select>
          </span>
          <div
            class="form-group"
          >
            <div
              v-if="filterByFeatured"
            >
              <div class="form-check">
                <input
                  type="checkbox"
                  class="form-check-input"
                  id="featured"
                  name="featured"
                  v-model="featured"
                  true-value="true"
                  false-value="false"
                >
                <label
                  class="form-check-label"
                  for="featured"
                >
                  Featured
                </label>
              </div>
            </div>
            <div
              v-if="filterByStaff"
            >
              <div class="form-check">
                <input
                  type="checkbox"
                  class="form-check-input"
                  id="staff"
                  name="staff"
                  v-model="staff"
                  true-value="true"
                  false-value="false"
                >
                <label
                  class="form-check-label"
                  for="staff"
                >
                  Staff
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="col-8">
          <input
            type="search"
            name="query"
            id="query"
            class="form-control preserve-page-state"
            v-model="query"
            :placeholder="placeholder"
          />
        </div>
        <div class="col col-2 text-right">
          <button
            type="submit"
            class="btn btn-primary"
          >
            Search
          </button>
        </div>
      </div>
    </fieldset>
  </form>
</template>
<script>

export default {
  data () {
    return {
      featured: false,
      query: undefined,
      selectedLbl: '',
      staff: false
    }
  },

  props: {
    filterByFeatured: {
      type: Boolean,
      default: false
    },

    filterByStaff: {
      type: Boolean,
      default: false
    },

    label: {
      type: String,
      default: 'Email'
    },

    labels: {
      type: Array,
      default: () => {
        return []
      }
    },

    legend: {
      type: String,
      default: ''
    },

    pageRef: {
      type: Object,
      default: () => { return {} },
      required: true
    },

    searchUrl: {
      type: String,
      default: undefined,
      required: true
    }
  },

  computed: {
    isPaymentSearch () {
      return this.selectedLbl === 'payments'
    },

    placeholder () {
      switch (this.selectedLbl) {
        case 'payments':
          return 'Payment/Transaction ID'
        default:
          return this.label || 'Email'
      }
    },

    searchEle () {
      return document.getElementById('query')
    }
  },

  methods: {
    isSelected (val) {
      return val === this.selectedLbl
    },

    searchQueryUpdated () {
      // Only emit if there's a query type and a query.
      if (this.selectedLbl && this.query) {
        let paramaterize = require('parameterize')

        this.$parent.$emit('searchQueryUpdated', {
          query: this.query,
          queryType: paramaterize(this.selectedLbl, undefined, '_')
        })
      }
    },

    labelSelected (ev) {
      this.selectedLbl = ev.target.value
      this.$parent.$emit('labelSelected', ev)
      this.searchQueryUpdated()
    },

    paginationSearch () {
      const query = this.$root.filterEmailSearchStr(
        this.searchQuery()
      )

      const cfg = {
        paging_method: 'post',
        resource_url: this.searchUrl,
        formdata: {
          featured: this.featured,
          query: query,
          staff: this.staff
        }
      }

      this.pageRef.$refs.pagination.$emit('changeConfig', cfg)
      this.pageRef.$refs.pagination.$emit('setFirstPage')
      this.pageRef.$refs.pagination.$emit('requestPage')
      this.searchQueryUpdated()
    },

    searchQuery () {
      return this.searchEle.value
    }
  },

  watch: {
    query (val, prior) {
      // Hacky method to reset search, if necessary.
      if (val === undefined || !val.length) {
        this.pageRef.$refs.pagination.$emit('reset')
      }

      this.searchQueryUpdated()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PagedSearchFieldForm.vue